import {
  TDEEProps,
  UserInput,
  Macros,
  Gender,
  ActivityLevel,
  Goal,
  ImperialUnits,
} from './types'

export function calculateBMR(
  weightInKg: number,
  heightInCM: number,
  age: number,
  selectedGender: Gender,
) {
  switch (selectedGender) {
    case Gender.Male:
      return 10 * weightInKg + 6.25 * heightInCM - 5 * age + 5
    case Gender.Female:
      return 10 * weightInKg + 6.25 * heightInCM - 5 * age - 161
  }

  return 10 * weightInKg + 6.25 * heightInCM - 5 * age - 161
}

export function calculateTDEE({ bmr, activity }: TDEEProps) {
  let multiplier = 1
  switch (activity) {
    case ActivityLevel.Sedentary:
      multiplier = 1.55
      break
    case ActivityLevel.Moderate:
      multiplier = 1.85
      break
    case ActivityLevel.Vigorous:
      multiplier = 2.2
      break
    case ActivityLevel.Extreme:
      multiplier = 2.4
      break
  }

  return bmr * multiplier
}

export function getCalculatedMacroResult({
  age,
  selectedGender,
  weightInKg,
  heightInCM,
  activity,
  selectedGoal,
}: UserInput) {
  const bmr = calculateBMR(weightInKg, heightInCM, age, selectedGender)
  let totalDailyEnergyExpendeture = calculateTDEE({ bmr, activity })
  let totalProtein = 0
  let totalFat = 0

  switch (selectedGoal) {
    case Goal.Lose:
      totalDailyEnergyExpendeture -= 500
      totalProtein = 3 * weightInKg
      totalFat = (totalDailyEnergyExpendeture * 0.3) / 9
      break
    case Goal.Maintain:
      totalProtein = 1.4 * weightInKg
      totalFat = (totalDailyEnergyExpendeture * 0.35) / 9
      break
    case Goal.Gain:
      totalDailyEnergyExpendeture += 500
      totalProtein = 2 * weightInKg
      totalFat = (totalDailyEnergyExpendeture * 0.3) / 9
      break
  }

  totalFat = Math.round(totalFat)

  // 9 calories per gram of fat
  const fatCalories = totalFat * 9
  // 4 calories per gram of protein/carbs
  const proteinCalories = Math.round(totalProtein * 4)
  const carbCalories =
    totalDailyEnergyExpendeture - proteinCalories - fatCalories
  const totalCarbohydrate = Math.round(carbCalories / 4)

  const macros: Macros = {
    fat: totalFat,
    protein: totalProtein,
    carbohydrate: totalCarbohydrate,
  }

  return macros
}

export function convertImperialToMetric(props: ImperialUnits) {
  const feetInCm = props.feet * 30.48
  const inchesInCm = props.inches * 2.54
  const heightInCm = Math.round(feetInCm + inchesInCm)

  const stoneInKg = props.stone * 6.35029
  const poundsInKg = props.pounds * 0.453592
  const weightInKg = Math.round(stoneInKg + poundsInKg)

  return {
    heightInCm,
    weightInKg,
  }
}
